export const formatT = (str, vars = {}) =>
  String(str).replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : `{${k}}`));

export const translations = {
  en: {
    authErrors: {
      invalidPhone: 'Enter a valid 10-digit mobile number',
      tooManyRequests: 'Too many attempts. Try again later.',
      captchaFailed: 'Verification failed. Refresh and try again.',
      invalidOtp: 'Invalid OTP',
      codeExpired: 'OTP expired. Request a new one.',
      missingOtp: 'Enter the 6-digit OTP',
      quotaExceeded: 'SMS quota exceeded. Try later.',
      appNotAuthorized: 'App not authorized for phone login.',
      phoneNotEnabled: 'Phone login not enabled in Firebase.',
      regionNotEnabled: 'Enable India in Firebase SMS region policy.',
      refererBlocked: 'API key blocked this site. Add mytownly-rides-driver.web.app to Google Cloud HTTP referrers and enable Identity Toolkit API.',
      networkFailed: 'Phone login blocked (ERR_FAILED). Fix API key referrers + Identity Toolkit API in Google Cloud, and add authorized domain in Firebase Auth.',
      noOtpSession: 'Request OTP first.',
      default: 'Something went wrong. Try again.',
    },
    login: {
      title: 'MyTownly Anna',
      subtitle: 'Auto partner · {city}',
      phoneLabel: 'Mobile number',
      phonePlaceholder: '10-digit number',
      sendOtp: 'Send OTP',
      verifyOtp: 'Verify & continue',
      verifying: 'Verifying…',
      resend: 'Resend OTP',
      resendWait: 'Resend in {s}s',
      changeNumber: 'Change number',
      invalidPhone: 'Enter valid 10-digit number',
      invalidOtp: 'Enter 6-digit OTP',
      otpSent: 'OTP sent to your phone',
      otpAutofillHint: 'OTP will autofill from SMS when possible — or type the 6 digits',
      otpExpiredHint: 'Tap Resend OTP for a fresh code',
      nameLabel: 'Your name',
      namePlaceholder: 'Full name',
      vehicleLabel: 'Auto number',
      vehiclePlaceholder: 'AP 39 XX 1234',
      invalidVehicle: 'Enter a valid auto number (for example, AP39TG4838)',
      photoLabel: 'Your photo',
      photoHint: 'Clear face photo — passengers and admin see this',
      autoPhotoLabel: 'Auto photo',
      autoPhotoHint: 'Photo of your auto (number plate visible)',
      photoRequired: 'Add your photo and auto photo to continue',
      changePhoto: 'Change',
      addPhoto: 'Add photo',
      takePhoto: 'Camera',
      chooseGallery: 'Gallery',
      photoPickError: 'Could not open the camera — pick from gallery instead',
      saveProfile: 'Submit for approval',
      legalConsentPrefix: 'By tapping Send OTP, you confirm you are 18+ and agree to our ',
      termsOfService: 'Terms of Service',
      and: ' & ',
      privacyPolicy: 'Privacy Policy',
      legalConsentSuffix: '.',
      signingIn: 'Signing you in…',
      loadingProfile: 'Loading your Anna profile',
    },
    dash: {
      goOnline: 'Go Online',
      goOffline: 'Go Offline',
      goOnlineNeedsLocation: 'Turn on your location to go online.',
      goOnlineNeedsFix: 'Could not get your location yet — move to an open area and try again.',
      goOnlineNeedsBattery: 'Allow MyTownly Anna to run in the background below, then tap Go Online again.',
      goOnlinePublishFailed: 'Could not publish your location — check your connection and try again.',
      goOnlineNeedsBackground: 'Could not prepare background tracking — check your connection and try again.',
      restoringSession: 'Restoring secure session…',
      reconnectToVerify: 'Reconnect to verify your session',
      waiting: 'Waiting for ride requests…',
      offlineTitle: 'You are offline',
      offlineHint: 'Go online to receive ride requests in {city}',
      pendingTitle: 'Account under review',
      pendingHint: 'Your profile is being verified. Contact support if this takes long.',
      blockedTitle: 'Account blocked',
      blockedHint: 'Contact MyTownly support for help.',
      newRide: 'New ride request',
      accept: 'Accept',
      confirmingRide: 'Confirming your ride…',
      confirmingRideHint: 'Just a moment',
      ignore: 'Ignore',
      fare: 'Fare',
      pickup: 'Pickup',
      drop: 'Drop',
      acceptError: 'Could not accept — ride may be taken',
      rideTaken: 'Another Anna accepted this ride',
      online: 'Online',
      offline: 'Offline',
      mapsError: 'Maps failed to load',
      offlineNet: 'No internet — reconnecting…',
      locationBlocked: 'Location is off — you won’t get rides. Tap to retry, then turn on GPS / grant permission.',
      locationBlockedHint: 'Still blocked. Open phone Settings → Location and allow MyTownly Anna.',
      geoDenied: 'Location is turned off for MyTownly Anna. Turn it on in Settings to go online.',
      openSettings: 'Open Settings',
      locationServicesOff: 'Device location is turned off. Turn on location so passengers can find you.',
      turnOnLocation: 'Turn On Location',
      cashCollect: 'Collect ₹{fare} cash at drop',
      farePastFee: '₹{ride} ride + ₹{fee} past fee',
      extraTipIncluded: '✨ +₹{tip} Extra Tip Included',
      customer: 'Customer',
      rider: 'Rider',
      bookedBy: '(Booked by {name})',
      todayRides: '{n} Rides',
      todayCash: '₹{amount}',
      dailyGoal: 'Daily Goal: ₹{goal}',
    },
    trip: {
      navBanner: '🧭 Open Google Maps Navigation',
      openGmaps: 'Navigate via Google Maps',
      toPickup: 'Navigate to pickup',
      toDrop: 'Navigate to drop',
      distToPickup: '{dist} to pickup',
      distToDrop: '{dist} to drop',
      atPickupBanner: 'You are at the pickup',
      arrived: 'Arrived at pickup',
      startTrip: 'Start trip',
      complete: 'Complete ride',
      confirmComplete: 'Cash collected — finish',
      back: 'Back',
      pickup: 'Pickup',
      drop: 'Drop',
      chat: 'Chat',
      collectCash: 'Collect ₹{fare} Cash',
      pastFeePill: '(incl. ₹{fee} past fee)',
      pastFeeBreakdown: '₹{ride} ride + ₹{fee} past cancellation fee',
      customer: 'Customer',
      rider: 'Rider',
      bookedBy: 'Booked by {name}',
      call: 'Call',
      callRider: 'Call rider',
      callBooker: 'Call booker',
      otpLabel: 'Enter customer OTP',
      otpHint: 'Ask passenger for the 4-digit code on their app',
      otpWrong: 'Wrong OTP — check with passenger',
      otpExpired: 'OTP expired — ask passenger to reopen their ride',
      otpRateLimit: 'Wait a moment and try again',
      otpStatusError: 'Tap Arrived at pickup first, then enter OTP',
      otpRetry: 'Couldn’t confirm the OTP — check your connection and try again.',
      otpRequired: 'Enter 4-digit OTP from customer',
      reportProblem: 'Report a problem',
      reportProblemHint: 'Use this if the trip can’t be finished — passenger no-show or a dispute. Our team will close the trip. You can then go back and take other rides.',
      reportProblemPlaceholder: 'What happened? (optional)',
      reportProblemSend: 'Send report & leave trip',
      tooFarPickup: 'Move closer to the pickup spot to mark arrived (within 250m).',
      tooFarDestination: 'Move closer to the drop-off spot to complete this trip (within 250m).',
      completeStatusError: 'Start the trip (verify OTP) before finishing it.',
      status_driver_assigned: 'Go to pickup',
      status_arrived: 'At pickup — verify OTP',
      status_started: 'Trip in progress',
      status_completed: 'Ride completed',
      completedToast: 'Ride completed! Ready for next.',
      passengerCancelled: 'Passenger cancelled this ride',
      rideCancelled: 'Ride was cancelled',
      cashHint: 'Passenger pays ₹{fare} cash to you',
      collectConfirm: 'Did you collect ₹{fare} cash from the passenger?',
      collectPaymentHeader: 'Collect ₹{fare} (Cash / UPI)',
      scanQrHint: 'Passenger can scan with PhonePe / GPay / Paytm',
      cashReceivedBtn: '✅ Received ₹{fare} — Complete Ride',
      sosCall: 'SOS call',
      sosWa: 'SOS WhatsApp',
      stepPickup: 'To pickup',
      stepArrived: 'At pickup',
      stepTrip: 'On trip',
      stepDone: 'Done',
      progressLabel: 'Trip progress',
      cancelShort: 'Cancel',
      completing: 'Completing…',
      sosShort: 'SOS',
    },
    sos: {
      title: 'Emergency',
      subtitleDriver: 'Get help fast. Every action also alerts the MyTownly safety team.',
      call112: 'Call 112',
      call112Sub: 'India national emergency — police, fire, ambulance',
      teamNote: 'Calling 112 or support also alerts the MyTownly safety team with your live location.',
      teamNotified: 'Calling 112 — MyTownly safety team alerted',
      callSupport: 'Call MyTownly support',
      callSupportSub: 'Talk to our team',
      alertContact: 'Alert my emergency contact',
      alertContactHint: 'Sends your live trip link on WhatsApp',
      alertMsg: 'SOS from MyTownly Anna ({city}). I need help. Live trip: {track}',
      alertedDone: 'Alert sent',
      alertFailed: 'Could not send alert',
      close: 'Close',
    },
    cancel: {
      open: 'Cancel ride',
      title: 'Cancel this ride?',
      subtitle: 'Tell us why — passenger will be notified',
      keep: 'Keep ride',
      confirm: 'Cancel ride',
      done: 'Ride cancelled',
      reasons: {
        passenger_no_show: 'Passenger not found / no show',
        wrong_location: 'Wrong pickup location',
        vehicle_issue: 'Vehicle issue',
        safety: 'Safety concern',
        other: 'Other',
      },
    },
    earnings: {
      title: 'Earnings',
      today: 'Today',
      todayRides: 'Today rides',
      week: 'This week',
      rides: 'rides',
      tips: 'Tips logged',
      avgRating: 'Avg rating',
      lifetime: 'Lifetime',
      loadOlder: 'Load older trips',
      loading: 'Loading…',
      cashNote: 'Cash is paid directly by passengers — this is your trip log.',
      tripHistory: 'Trip history',
      empty: 'No trips yet',
      filter_all: 'All',
      filter_completed: 'Completed',
      filter_cancelled: 'Cancelled',
      status_completed: 'Completed',
      status_cancelled: 'Cancelled',
      status_started: 'On trip',
      status_driver_assigned: 'Assigned',
      status_arrived: 'Arrived',
      status_searching: 'Searching',
      duesLabel: 'PENDING ADMIN DUES (₹5/RIDE, ₹10 AT NIGHT)',
      duesPayVia: 'Pay Admin via PhonePe / GPay or Cash',
      duesHide: 'Hide Pay Info',
      duesPay: '💳 Pay Dues',
      duesPayToAdmin: 'Pay Dues to Admin (MyTownly Piler)',
      duesPayButton: '📱 Pay {phone} on GPay / PhonePe',
      duesCopied: 'Copied {phone}',
    },
    profile: {
      title: 'Profile',
      logout: 'Logout',
      logoutConfirmTitle: 'Log out?',
      logoutConfirmBody: 'You will need to verify your phone number again to sign back in.',
      logoutConfirmYes: 'Log out',
      vehicle: 'Vehicle',
      phone: 'Phone',
      uploadPhoto: 'Upload photo',
      photoHint: 'Passengers see this when you accept a ride',
      uploadAutoPhoto: 'Upload auto photo',
      autoPhotoHint: 'Number plate should be visible for admin approval',
      photoSaved: 'Photo saved',
      photoPending: 'Photo submitted — live after admin approval',
      photoPendingHint: 'New photos wait for admin approval',
      photoUploadFailed: 'Photo not uploaded — retry when you have a stronger signal.',
      upiSectionTitle: 'Payment UPI & QR Code',
      upiSectionSub: 'Passengers can scan to pay you directly on drop',
      upiIdLabel: 'Your UPI ID (VPA)',
      upiIdPlaceholder: 'e.g. 9848012345@ybl or name@oksbi',
      saveUpiBtn: 'Save UPI ID',
      upiSavedToast: 'UPI ID saved successfully!',
      uploadCustomQr: 'Upload Custom QR Photo',
      qrUploadedToast: 'Custom QR photo saved!',
      qrActiveBadge: 'QR Active',
      qrActiveHint: 'Your QR will automatically appear on trip completion',
      removeUpi: 'Remove UPI',
      tipsTotal: 'Tips total',
      lifetimeRideEarnings: 'Lifetime ride earnings',
      rating: 'Rating',
      voiceAnnounceTitle: 'Voice Announcements',
      voiceAnnounceSub: 'Read pickup & fare aloud in Telugu',
      voiceEnabledToast: 'Voice announcements enabled 🔊',
      voiceDisabledToast: 'Voice announcements muted 🔇',
      support: 'Support',
      callSupport: 'Call',
      waSupport: 'WhatsApp',
      rateApp: 'Rate MyTownly Anna on Play Store',
      rateAppSub: 'Share your experience with MyTownly',
      legalSectionTitle: '🔒 Privacy & Legal',
      legalSectionSub: 'Your privacy, KYC document security, and platform rules.',
      legalDocsHeading: 'Legal Documents',
      privacyTitle: '🛡️ Privacy Policy',
      privacySub: 'Driver data protection & location policy',
      termsTitle: '📜 Terms of Service',
      termsSub: 'Driver terms, fares & code of conduct',
      safetyHeading: 'Safety & Guidelines',
      safetyTitle: '🦺 Safety Guidelines',
      safetySub: 'Passenger & driver safety standards',
      deleteTitle: '🗑️ Delete Account',
      deleteSub: 'Permanently erase driver account & profile',
    },
    deleteAccount: {
      title: 'Delete Captain Account',
      subtitle: 'Permanently remove your captain profile and records',
      close: 'Close',
      warning: 'Irreversible Action: Deleting your captain account permanently revokes your driver registration, vehicle profile, KYC documents, and earnings history.',
      phoneLabel: 'REGISTERED PHONE NUMBER',
      phonePlaceholder: '10-digit mobile number',
      reasonLabel: 'REASON FOR LEAVING',
      feedbackLabel: 'ADDITIONAL FEEDBACK (OPTIONAL)',
      feedbackPlaceholder: 'Tell us how we could improve…',
      reasons: {
        not_driving: 'No longer driving with MyTownly',
        privacy_concerns: 'Privacy & data concerns',
        switched_service: 'Switched to another platform',
        vehicle_changed: 'Vehicle changed / sold',
        other: 'Other reason',
      },
      submit: 'Confirm & Request Deletion',
      submitting: 'Submitting Request…',
      keep: 'Keep My Account',
      invalidPhone: 'Please enter a valid 10-digit phone number',
      submitted: 'Driver account deletion request submitted',
      failed: 'Could not submit request. Please contact support.',
      receivedTitle: 'Request Received',
      receivedBody: 'Your captain account deletion request for +91 {phone} has been registered. Our privacy officer will process the erasure within 30 days.',
      trackWhatsapp: '💬 Track via WhatsApp Support',
    },
    privacyCenter: {
      title: 'Privacy & Data Center',
      subtitle: 'Manage your captain profile, preferences, and privacy',
      close: 'Close',
      gpsNoticeLabel: 'Driver GPS Notice:',
      gpsNoticeBody: 'While Online, your location is shared to match bookings and track active trips. Going Offline immediately halts sharing.',
      legalHeading: 'Legal & Policies',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      prefsHeading: 'Privacy Preferences',
      analyticsOptOut: 'Analytics Opt-Out',
      analyticsOptOutSub: 'Disable usage diagnostics & event telemetry. Core trip processing is unaffected.',
      promoUpdates: 'Promotional Updates',
      promoUpdatesSub: 'Receive occasional driver community bonuses & town announcements.',
      savePrefs: 'Save Preferences',
      saving: 'Saving…',
      prefsUpdated: 'Preferences updated',
      prefsFailed: 'Could not save preferences',
      nomineeHeading: 'Trusted Nominee',
      nomineeSub: 'Add a trusted contact who can manage your account and records if you are unable to.',
      nomineeNamePlaceholder: 'Nominee full name',
      nomineePhonePlaceholder: 'Nominee 10-digit phone',
      saveNominee: 'Save Nominee',
      nomineeInvalidPhone: 'Enter a valid 10-digit nominee phone',
      nomineeSaved: 'Nominee saved',
      nomineeCleared: 'Nominee cleared',
      nomineeFailed: 'Could not save nominee',
      rightsHeading: 'Your Data & Account',
      downloadData: 'Download Personal Data',
      downloadDataSub: 'Export a copy of your processed records',
      accessSubmitted: 'Access request submitted',
      accessFailed: 'Could not submit request',
      deleteTitle: 'Delete Account & Erase Data',
      deleteSub: 'Permanent removal of your profile',
      grievanceHeading: 'File a Privacy Grievance',
      grievanceSub: 'Have an issue regarding how your data is handled? Submit directly to our compliance desk.',
      grievancePlaceholder: 'Describe your concern in detail…',
      submitGrievance: 'Submit Grievance',
      submitting: 'Submitting…',
      grievanceShort: 'Please describe your concern (min 10 characters)',
      grievanceSubmitted: 'Grievance submitted',
      grievanceFailed: 'Could not submit grievance',
      grievanceOfficer: 'Grievance Officer:',
      whatsappDesk: 'WhatsApp Desk ›',
    },
    chat: {
      title: 'Chat',
      open: 'Chat',
      empty: 'No messages yet',
      placeholder: 'Message passenger…',
      send: 'Send',
      chipOnMyWay: 'On my way 🛺',
      chipArrived: 'Arrived at pickup 📍',
      chipTraffic: 'Stuck in traffic 🚦',
      chipEta: '2 mins away ⏱️',
      chipCall: 'Please answer the call 📞',
    },
    push: {
      enable: 'Enable ride alerts',
      enabled: 'Notifications on',
      denied: 'Could not enable notifications',
      noVapid: 'Set REACT_APP_FIREBASE_VAPID_KEY',
      promptTitle: 'Get new ride alerts',
      promptBody: 'Turn on notifications so you never miss a request.',
      later: 'Later',
    },
    battery: {
      title: 'Keep getting ride requests',
      body: 'Some phones (Xiaomi, Vivo, Oppo and others) stop apps in the background to save power. Allow MyTownly to run without limits so ride requests still reach you when your screen is off.',
      allow: 'Allow',
      later: 'Not now',
      oemToggle: 'Using Xiaomi, Vivo or Oppo?',
      oemHelp: 'Also open phone Settings → Apps → MyTownly Anna → Autostart (or “Allow background activity”) and turn it on.',
      bannerText: 'Ride requests may be delayed on this phone',
      bannerFix: 'Fix',
      openFailed: 'Could not open battery settings — open phone Settings → Apps → MyTownly Anna → Battery.',
    },
    tour: {
      next: 'Next',
      skip: 'Skip',
      done: 'Got it',
      online: {
        title: 'Go online',
        body: 'Tap Go Online to start receiving ride requests near you.',
      },
      accept: {
        title: 'Accept fast',
        body: 'New requests ring with a timer. Accept before it expires.',
      },
      otp: {
        title: 'Start with OTP',
        body: 'At pickup, ask for the 4-digit OTP shown on the passenger app.',
      },
      cash: {
        title: 'Collect cash',
        body: 'At drop, collect the fare in cash, then tap Complete.',
      },
    },
    docs: {
      title: 'My Documents & Vehicle',
      subtitle: 'KYC & transport permits for Piler fleet',
      verifiedBadge: 'Verified Partner 🛡️',
      pendingBadge: 'Pending Verification ⏳',
      missingBadge: 'Documents Required ⚠️',
      dlTitle: 'Driving Licence (DL)',
      dlSub: 'Commercial transport 3-wheeler licence',
      dlNumberLabel: 'DL Number',
      dlNumberPlaceholder: 'e.g. AP04 20200012345',
      dlExpiryLabel: 'DL Expiry Date',
      dlFrontPhoto: 'DL Front Photo',
      dlBackPhoto: 'DL Back Photo',
      rcTitle: 'Vehicle RC Card',
      rcSub: 'Registration Certificate of your Auto',
      rcNumberLabel: 'RC / Plate Number',
      rcOwnerLabel: 'Owner Name (as on RC)',
      rcPhoto: 'RC Card Photo',
      insuranceTitle: 'Auto Insurance Policy',
      insuranceSub: 'Commercial passenger liability policy',
      insuranceNumberLabel: 'Policy Number',
      insuranceExpiryLabel: 'Insurance Expiry Date',
      insurancePhoto: 'Policy Copy Photo',
      vehicleSpecsTitle: 'Vehicle & Emergency Specs',
      fuelTypeLabel: 'Fuel Type',
      petrol: 'Petrol',
      diesel: 'Diesel',
      lpg: 'LPG Gas',
      cng: 'CNG Gas',
      electric: 'Electric (EV)',
      bloodGroupLabel: 'Blood Group',
      emergencyContactLabel: 'Emergency Nominee Phone',
      saveDocsBtn: 'Save & Submit Documents',
      savedToast: 'Documents saved & submitted for verification!',
      uploadFailed: 'Upload failed — retry when you have a stronger signal. Re-add the photo before saving.',
      uploadPhotoBtn: 'Upload Photo',
      changePhotoBtn: 'Change Photo',
      statusVerified: 'Verified ✓',
      statusPending: 'Under Review ⏳',
      statusRejected: 'Needs Re-upload ✕',
      statusNotUploaded: 'Not Uploaded',
      rejectionReason: 'Admin Note: {reason}',
      backToProfile: 'Back to Profile',
      menuRowTitle: 'Documents & Vehicle KYC',
      menuRowSub: 'Driving Licence, RC, Insurance & Specs',
      priorityTag: 'Priority 1.2x',
      heroVerified: 'All transport permits verified. You have Verified Partner priority dispatch.',
      heroPending: 'Your uploaded documents are being reviewed by the MyTownly admin team.',
      heroMissing: 'Upload clear photos of your DL, RC, Insurance, and Aadhaar to unlock the Verified Partner badge.',
      frontPhoto: 'Front Photo',
      backPhoto: 'Back Photo',
      uploading: 'Uploading…',
      tapToCapture: 'Tap to capture',
      rcOwnerPlaceholder: 'Full owner name',
      uploadRcBtn: 'Upload RC Card / Smart Card',
      rcDropSub: 'Clear photo of registration certificate',
      insuranceNumberPlaceholder: 'Policy / Cover Note #',
      uploadInsuranceBtn: 'Upload Insurance Policy Copy',
      insuranceDropSub: 'Current valid policy document',
      aadhaarTitle: 'Aadhaar Card',
      aadhaarSub: 'Government identity proof (mandatory)',
      aadhaarNumberLabel: 'Aadhaar Number',
      aadhaarNumberPlaceholder: '1234 5678 9012',
      aadhaarLast4Note: 'Only the last 4 digits are stored. The full number is checked from your photo, never saved.',
      aadhaarPhoto: 'Aadhaar Card Photo',
      uploadAadhaarBtn: 'Upload Aadhaar Card',
      aadhaarDropSub: 'Clear photo of the front of your Aadhaar',
      vehicleSpecsSub: 'Fuel type, blood group, & highway emergency',
    },
    nav: { home: 'Home', earnings: 'Earnings', profile: 'Profile' },
    requiredUpdate: {
      versionLine: 'Version {version} or newer is required',
      updateNow: 'Update now',
      opening: 'Opening Google Play…',
      idleNote: 'This is shown only outside a trip and when there is no open ride request.',
    },
    intertown: {
      eyebrow: 'INTERTOWN ASSIGNMENT',
      destinationFallback: 'Destination',
      oneWay: 'One way',
      returnTrip: 'Return trip',
      pickupLabel: 'Pickup:',
      pickupFallback: 'See passenger details',
      passengerFallback: 'Passenger',
      passengerLabel: 'Passenger',
      tripLabel: 'Trip',
      distanceLabel: 'Distance',
      fareLabel: 'Fare',
      offerStatus: 'New offer',
      toPickupStatus: 'Go to pickup',
      otpStatus: 'Verify pickup',
      onTripStatus: 'Trip in progress',
      destinationStatus: 'At destination',
      returnStatus: 'Returning',
      decline: 'Decline',
      accept: 'Accept Intertown',
      navigatePickup: 'Navigate to pickup',
      navigateDestination: 'Navigate to destination',
      arrivedAtPickup: 'Arrived at pickup',
      updating: 'Updating…',
      startTrip: 'Start trip',
      otpHint: 'Ask the passenger for the 4-digit code on their Intertown screen',
      reachedDestination: 'Reached destination',
      waitingStarted: 'Waiting time has started.',
      startReturn: 'Start return',
      finalFare: 'Final fare {amount}',
      completeTrip: 'Complete trip',
      offerDeclined: 'Intertown offer declined',
      tripUpdated: 'Intertown trip updated',
      updateFailed: 'Could not update Intertown trip',
      waitingForLocation: 'Waiting for your current GPS location. Keep Location on and the app open to confirm pickup arrival.',
      availableTitle: 'Available Intertown trips',
      availableSubtitle: 'First Anna to claim gets the trip',
      claim: 'Claim',
      notNow: 'Not now',
      claimed: 'Intertown trip claimed',
      declinedOpen: 'You will not see new Intertown offers for 10 minutes',
      claimFailed: 'This Intertown trip is no longer available',
    },
  },
  te: {
    authErrors: {
      invalidPhone: 'సరైన 10 అంకెల మొబైల్ నంబర్ ఇవ్వండి',
      tooManyRequests: 'చాలా ప్రయత్నాలు. తర్వాత ప్రయత్నించండి.',
      captchaFailed: 'ధృవీకరణ విఫలం. రిఫ్రెష్ చేసి మళ్ళీ ప్రయత్నించండి.',
      invalidOtp: 'తప్పు OTP',
      codeExpired: 'OTP గడువు ముగిసింది.',
      missingOtp: '6 అంకెల OTP ఇవ్వండి',
      quotaExceeded: 'SMS పరిమితి. తర్వాత ప్రయత్నించండి.',
      appNotAuthorized: 'ఫోన్ లాగిన్ అనుమతి లేదు.',
      phoneNotEnabled: 'Firebase లో ఫోన్ లాగిన్ ఎనేబుల్ చేయండి.',
      networkFailed: 'నెట్వర్క్ లోపం.',
      regionNotEnabled: 'Firebase లో India SMS region ఎనేబుల్ చేయండి.',
      refererBlocked: 'డొమైన్ అనుమతి లేదు.',
      noOtpSession: 'ముందు OTP అడగండి.',
      default: 'ఏదో తప్పు జరిగింది.',
    },
    login: {
      title: 'MyTownly Anna',
      subtitle: 'ఆటో పార్ట్నర్ · {city}',
      phoneLabel: 'మొబైల్ నంబర్',
      phonePlaceholder: '10 అంకెల నంబర్',
      sendOtp: 'OTP పంపు',
      verifyOtp: 'ధృవీకరించి కొనసాగు',
      verifying: 'ధృవీకరిస్తున్నాం…',
      resend: 'OTP మళ్ళీ పంపు',
      resendWait: '{s}సె లో మళ్ళీ పంపు',
      changeNumber: 'నంబర్ మార్చు',
      invalidPhone: 'సరైన 10 అంకెల నంబర్',
      invalidOtp: '6 అంకెల OTP',
      otpSent: 'మీ ఫోన్‌కు OTP పంపాం',
      otpAutofillHint: 'సాధ్యమైతే SMS నుండి OTP ఆటోఫిల్ అవుతుంది — లేదా 6 అంకెలు టైప్ చేయండి',
      otpExpiredHint: 'కొత్త కోడ్ కోసం OTP మళ్ళీ పంపు నొక్కండి',
      nameLabel: 'మీ పేరు',
      namePlaceholder: 'పూర్తి పేరు',
      vehicleLabel: 'ఆటో నంబర్',
      vehiclePlaceholder: 'AP 39 XX 1234',
      invalidVehicle: 'సరైన ఆటో నంబర్ నమోదు చేయండి (ఉదా: AP39TG4838)',
      photoLabel: 'మీ ఫోటో',
      photoHint: 'స్పష్టమైన ముఖ ఫోటో — ప్యాసింజర్ మరియు అడ్మిన్ చూస్తారు',
      autoPhotoLabel: 'ఆటో ఫోటో',
      autoPhotoHint: 'మీ ఆటో ఫోటో (నంబర్ ప్లేట్ కనిపించాలి)',
      photoRequired: 'కొనసాగడానికి మీ ఫోటో మరియు ఆటో ఫోటో జోడించండి',
      changePhoto: 'మార్చు',
      addPhoto: 'ఫోటో జోడించు',
      takePhoto: 'కెమెరా',
      chooseGallery: 'గ్యాలరీ',
      photoPickError: 'కెమెరా తెరవలేకపోయాం — గ్యాలరీ నుండి ఎంచుకోండి',
      saveProfile: 'అప్రూవల్ కోసం సబ్మిట్',
      legalConsentPrefix: 'కొనసాగడం ద్వారా, మీరు 18+ అని మరియు మా ',
      termsOfService: 'నిబంధనలు',
      and: ' & ',
      privacyPolicy: 'గోప్యతా విధానాన్ని',
      legalConsentSuffix: ' అంగీకరిస్తున్నారు.',
      signingIn: 'సైన్ ఇన్ అవుతోంది…',
      loadingProfile: 'మీ అన్న ప్రొఫైల్ లోడ్ అవుతోంది',
    },
    dash: {
      goOnline: 'ఆన్‌లైన్ అవ్వండి',
      goOffline: 'ఆఫ్‌లైన్ అవ్వండి',
      goOnlineNeedsLocation: 'ఆన్‌లైన్ అవ్వాలంటే లొకేషన్ ఆన్ చేయండి.',
      goOnlineNeedsFix: 'మీ లొకేషన్ ఇంకా దొరకలేదు — ఖాళీ ప్రదేశంలోకి వెళ్లి మళ్లీ ప్రయత్నించండి.',
      goOnlineNeedsBattery: 'కింద MyTownly Annaను బ్యాక్‌గ్రౌండ్‌లో రన్ అవ్వడానికి అనుమతించి, మళ్లీ ఆన్‌లైన్ అవ్వండి నొక్కండి.',
      goOnlinePublishFailed: 'మీ లొకేషన్ పంపలేకపోయాం — ఇంటర్నెట్ కనెక్షన్ చెక్ చేసి మళ్లీ ప్రయత్నించండి.',
      goOnlineNeedsBackground: 'బ్యాక్‌గ్రౌండ్ లొకేషన్ సిద్ధం కాలేదు — ఇంటర్నెట్ కనెక్షన్ చెక్ చేసి మళ్లీ ప్రయత్నించండి.',
      restoringSession: 'సురక్షిత సెషన్‌ను పునరుద్ధరిస్తోంది…',
      reconnectToVerify: 'మీ సెషన్‌ను ధృవీకరించడానికి ఇంటర్నెట్‌కు కనెక్ట్ అవ్వండి',
      waiting: 'రైడ్ రిక్వెస్ట్ కోసం వేచి…',
      offlineTitle: 'మీరు ఆఫ్‌లైన్',
      offlineHint: '{city} లో రైడ్‌లు పొందడానికి ఆన్‌లైన్ అవ్వండి',
      pendingTitle: 'ఖాతా సమీక్షలో',
      pendingHint: 'మీ ప్రొఫైల్ ధృవీకరణలో ఉంది.',
      blockedTitle: 'ఖాతా బ్లాక్',
      blockedHint: 'సహాయం కోసం MyTownly సపోర్ట్‌ను సంప్రదించండి.',
      newRide: 'కొత్త రైడ్ రిక్వెస్ట్',
      accept: 'అంగీకరించు',
      confirmingRide: 'మీ రైడ్‌ను నిర్ధారిస్తున్నాం…',
      confirmingRideHint: 'కొద్ది క్షణం ఆగండి',
      ignore: 'వదిలేయి',
      fare: 'ఛార్జ్',
      pickup: 'పికప్',
      drop: 'డ్రాప్',
      acceptError: 'అంగీకరించలేకపోయాం — రైడ్ తీసుకున్నారు',
      rideTaken: 'ఈ రైడ్‌ను మరో అన్నా ఇప్పటికే అంగీకరించారు',
      online: 'ఆన్‌లైన్',
      offline: 'ఆఫ్‌లైన్',
      mapsError: 'మ్యాప్ లోడ్ కాలేదు',
      offlineNet: 'ఇంటర్నెట్ లేదు — కనెక్ట్ అవుతోంది…',
      locationBlocked: 'లొకేషన్ ఆఫ్‌లో ఉంది — రైడ్‌లు రావు. మళ్లీ ప్రయత్నించండి, GPS / అనుమతి ఆన్ చేయండి.',
      locationBlockedHint: 'ఇంకా బ్లాక్‌లో ఉంది. ఫోన్ సెట్టింగ్స్ → లొకేషన్ లో MyTownly Anna కి అనుమతించండి.',
      geoDenied: 'MyTownly Anna కోసం లొకేషన్ ఆఫ్‌లో ఉంది. ఆన్‌లైన్ అవ్వాలంటే సెట్టింగ్స్‌లో ఆన్ చేయండి.',
      openSettings: 'సెట్టింగ్స్ తెరవండి',
      locationServicesOff: 'డివైస్ లొకేషన్ ఆఫ్‌లో ఉంది. ప్రయాణికులు మిమ్మల్ని కనుగొనేలా లొకేషన్ ఆన్ చేయండి.',
      turnOnLocation: 'లొకేషన్ ఆన్ చేయండి',
      cashCollect: 'డ్రాప్‌లో ₹{fare} నగదు తీసుకోండి',
      farePastFee: '₹{ride} రైడ్ + ₹{fee} పాత రుసుము',
      extraTipIncluded: '✨ +₹{tip} అదనపు టిప్ ఉంది',
      customer: 'కస్టమర్',
      rider: 'రైడర్',
      bookedBy: '({name} బుక్ చేశారు)',
      todayRides: '{n} ట్రిప్స్',
      todayCash: '₹{amount}',
      dailyGoal: 'లక్ష్యం: ₹{goal}',
    },
    trip: {
      navBanner: '🧭 గూగుల్ మ్యాప్స్ నావిగేషన్ ప్రారంభించు',
      openGmaps: 'గూగుల్ మ్యాప్స్ ద్వారా నావిగేట్ చేయండి',
      toPickup: 'పికప్‌కు నావిగేట్',
      toDrop: 'డ్రాప్‌కు నావిగేట్',
      distToPickup: 'పికప్‌కు {dist}',
      distToDrop: 'డ్రాప్‌కు {dist}',
      atPickupBanner: 'మీరు పికప్ దగ్గర ఉన్నారు',
      arrived: 'పికప్‌కు చేరుకున్నాను',
      startTrip: 'ట్రిప్ ప్రారంభించు',
      complete: 'రైడ్ పూర్తి',
      confirmComplete: 'నగదు తీసుకున్నా — పూర్తి',
      back: 'వెనక్కి',
      pickup: 'పికప్',
      drop: 'డ్రాప్',
      chat: 'చాట్',
      collectCash: '₹{fare} నగదు తీసుకోండి',
      pastFeePill: '(₹{fee} పాత రుసుముతో కలిపి)',
      pastFeeBreakdown: '₹{ride} రైడ్ + ₹{fee} పాత రద్దు రుసుము',
      customer: 'కస్టమర్',
      rider: 'రైడర్',
      bookedBy: '{name} బుక్ చేశారు',
      call: 'కాల్',
      callRider: 'రైడర్‌కు కాల్',
      callBooker: 'బుకర్‌కు కాల్',
      otpLabel: 'కస్టమర్ OTP ఇవ్వండి',
      otpHint: 'ప్యాసెంజర్ యాప్‌లో ఉన్న 4 అంకెల కోడ్ అడగండి',
      otpWrong: 'తప్పు OTP — ప్యాసెంజర్‌తో తనిఖీ చేయండి',
      otpExpired: 'OTP గడువు ముగిసింది — ప్యాసెంజర్‌ను యాప్ తెరవమనండి',
      otpRateLimit: 'కొద్ది సేపు వేచి మళ్ళీ ప్రయత్నించండి',
      otpStatusError: 'ముందు పికప్‌కు చేరుకున్నట్లు నొక్కండి, తర్వాత OTP ఇవ్వండి',
      otpRetry: 'OTP నిర్ధారించలేకపోయాం — మీ కనెక్షన్ చూసి మళ్ళీ ప్రయత్నించండి.',
      otpRequired: 'కస్టమర్ OTP 4 అంకెలు',
      reportProblem: 'సమస్యను నివేదించండి',
      reportProblemHint: 'ట్రిప్ పూర్తి చేయలేకపోతే దీన్ని వాడండి — ప్యాసెంజర్ రాలేదు లేదా వివాదం. మా బృందం ట్రిప్‌ను ముగిస్తుంది. తర్వాత మీరు వెనక్కి వెళ్లి ఇతర రైడ్‌లు తీసుకోవచ్చు.',
      reportProblemPlaceholder: 'ఏమి జరిగింది? (ఐచ్ఛికం)',
      reportProblemSend: 'నివేదిక పంపి ట్రిప్ నుండి బయటకు రండి',
      tooFarPickup: 'చేరుకున్నట్లు గుర్తించడానికి పికప్ దగ్గరగా వెళ్లండి (250మీ లోపు).',
      tooFarDestination: 'ట్రిప్ పూర్తి చేయడానికి డ్రాప్ దగ్గరగా వెళ్లండి (250మీ లోపు).',
      completeStatusError: 'ముగించే ముందు ట్రిప్ ప్రారంభించండి (OTP నిర్ధారించండి).',
      status_driver_assigned: 'పికప్‌కు వెళ్ళండి',
      status_arrived: 'పికప్‌వద్ద — OTP ధృవీకరించండి',
      status_started: 'ప్రయాణం జరుగుతోంది',
      status_completed: 'రైడ్ పూర్తి',
      completedToast: 'రైడ్ పూర్తి! తదుపరి రైడ్ కోసం సిద్ధం.',
      passengerCancelled: 'ప్యాసింజర్ రైడ్‌ను రద్దు చేశారు',
      rideCancelled: 'రైడ్ రద్దు చేయబడింది',
      cashHint: 'ప్యాసింజర్ మీకు ₹{fare} నగదు చెల్లిస్తారు',
      collectConfirm: 'ప్యాసింజర్ నుండి ₹{fare} నగదు తీసుకున్నారా?',
      collectPaymentHeader: '₹{fare} వసూలు చేయండి (నగదు / UPI)',
      scanQrHint: 'ప్రయాణికుడు PhonePe / GPay / Paytm తో స్కాన్ చేయవచ్చు',
      cashReceivedBtn: '✅ ₹{fare} అందింది — ట్రిప్ పూర్తి చేయండి',
      sosCall: 'SOS కాల్',
      sosWa: 'SOS WhatsApp',
      stepPickup: 'పికప్‌కు',
      stepArrived: 'పికప్‌వద్ద',
      stepTrip: 'ప్రయాణం',
      stepDone: 'పూర్తి',
      progressLabel: 'ట్రిప్ ప్రోగ్రెస్',
      cancelShort: 'రద్దు',
      completing: 'పూర్తవుతోంది…',
      sosShort: 'SOS',
    },
    sos: {
      title: 'ఎమర్జెన్సీ',
      subtitleDriver: 'త్వరగా సహాయం పొందండి. ప్రతి చర్య MyTownly సేఫ్టీ టీమ్‌కు కూడా అలర్ట్ ఇస్తుంది.',
      call112: '112 కు కాల్',
      call112Sub: 'భారత జాతీయ ఎమర్జెన్సీ — పోలీస్, ఫైర్, అంబులెన్స్',
      teamNote: '112 లేదా సపోర్ట్‌కు కాల్ చేస్తే MyTownly సేఫ్టీ టీమ్‌కు మీ లైవ్ లొకేషన్‌తో అలర్ట్ వెళ్తుంది.',
      teamNotified: '112 కు కాల్ చేస్తోంది — MyTownly సేఫ్టీ టీమ్‌కు అలర్ట్ అయింది',
      callSupport: 'MyTownly సపోర్ట్ కాల్',
      callSupportSub: 'మా టీమ్‌తో మాట్లాడండి',
      alertContact: 'నా ఎమర్జెన్సీ కాంటాక్ట్‌కు అలర్ట్',
      alertContactHint: 'మీ లైవ్ ట్రిప్ లింక్‌ను WhatsAppలో పంపుతుంది',
      alertMsg: 'MyTownly Anna SOS ({city}). నాకు సహాయం కావాలి. లైవ్ ట్రిప్: {track}',
      alertedDone: 'అలర్ట్ పంపబడింది',
      alertFailed: 'అలర్ట్ పంపలేకపోయాం',
      close: 'మూసివేయి',
    },
    cancel: {
      open: 'రైడ్ రద్దు',
      title: 'రైడ్ రద్దు చేయాలా?',
      subtitle: 'కారణం చెప్పండి — ప్యాసింజర్‌కు తెలుస్తుంది',
      keep: 'రైడ్ ఉంచు',
      confirm: 'రద్దు చేయి',
      done: 'రైడ్ రద్దు అయింది',
      reasons: {
        passenger_no_show: 'ప్యాసింజర్ కనిపించలేదు',
        wrong_location: 'తప్పు పికప్ లొకేషన్',
        vehicle_issue: 'వాహన సమస్య',
        safety: 'భద్రతా సమస్య',
        other: 'ఇతరం',
      },
    },
    earnings: {
      title: 'ఆదాయం',
      today: 'ఈరోజు',
      todayRides: 'ఈ రోజు రైడ్స్',
      week: 'ఈ వారం',
      rides: 'రైడ్స్',
      tips: 'టిప్స్',
      avgRating: 'సగటు రేటింగ్',
      lifetime: 'మొత్తం',
      loadOlder: 'పాత ట్రిప్‌లు చూడండి',
      loading: 'లోడ్ అవుతోంది…',
      cashNote: 'నగదు నేరుగా ప్యాసింజర్ నుండి — ఇది మీ ట్రిప్ లాగ్.',
      tripHistory: 'ట్రిప్ చరిత్ర',
      empty: 'ఇంకా ట్రిప్స్ లేవు',
      filter_all: 'అన్నీ',
      filter_completed: 'పూర్తి',
      filter_cancelled: 'రద్దు',
      status_completed: 'పూర్తి',
      status_cancelled: 'రద్దు',
      status_started: 'ప్రయాణంలో',
      status_driver_assigned: 'కేటాయించబడింది',
      status_arrived: 'వచ్చారు',
      status_searching: 'వెతుకుతోంది',
      duesLabel: 'పెండింగ్ అడ్మిన్ బకాయి (₹5/రైడ్, రాత్రి ₹10)',
      duesPayVia: 'PhonePe / GPay లేదా నగదు ద్వారా అడ్మిన్‌కు చెల్లించండి',
      duesHide: 'చెల్లింపు వివరాలు దాచండి',
      duesPay: '💳 బకాయి చెల్లించండి',
      duesPayToAdmin: 'అడ్మిన్‌కు బకాయి చెల్లించండి (MyTownly Piler)',
      duesPayButton: '📱 GPay / PhonePe లో {phone}కి చెల్లించండి',
      duesCopied: '{phone} కాపీ చేయబడింది',
    },
    profile: {
      title: 'ప్రొఫైల్',
      logout: 'లాగౌట్',
      logoutConfirmTitle: 'లాగౌట్ చేయాలా?',
      logoutConfirmBody: 'మళ్లీ సైన్ ఇన్ చేయడానికి మీ ఫోన్ నంబర్‌ను తిరిగి ధృవీకరించాలి.',
      logoutConfirmYes: 'లాగౌట్',
      vehicle: 'వాహనం',
      phone: 'ఫోన్',
      uploadPhoto: 'ఫోటో అప్‌లోడ్',
      photoHint: 'రైడ్ అంగీకరించినప్పుడు ప్యాసింజర్ ఇది చూస్తారు',
      uploadAutoPhoto: 'ఆటో ఫోటో అప్‌లోడ్',
      autoPhotoHint: 'అడ్మిన్ అప్రూవల్ కోసం నంబర్ ప్లేట్ కనిపించాలి',
      photoSaved: 'ఫోటో సేవ్ అయింది',
      photoPending: 'ఫోటో పంపాం — అడ్మిన్ అప్రూవ్ తర్వాత లైవ్ అవుతుంది',
      photoPendingHint: 'కొత్త ఫోటోలు అడ్మిన్ అప్రూవల్ కోసం వేచి ఉంటాయి',
      photoUploadFailed: 'ఫోటో అప్‌లోడ్ కాలేదు — సిగ్నల్ బాగున్నప్పుడు మళ్లీ ప్రయత్నించండి.',
      upiSectionTitle: 'చెల్లింపు UPI & QR కోడ్',
      upiSectionSub: 'డ్రాప్ వద్ద ప్రయాణికులు స్కాన్ చేసి నేరుగా మీకు చెల్లించవచ్చు',
      upiIdLabel: 'మీ UPI ID (VPA)',
      upiIdPlaceholder: 'ఉదా: 9848012345@ybl లేదా పేరు@oksbi',
      saveUpiBtn: 'UPI సేవ్ చేయండి',
      upiSavedToast: 'UPI ID సేవ్ చేయబడింది!',
      uploadCustomQr: 'కస్టమ్ QR ఫోటో అప్‌లోడ్ చేయండి',
      qrUploadedToast: 'QR ఫోటో సేవ్ చేయబడింది!',
      qrActiveBadge: 'QR యాక్టివ్',
      qrActiveHint: 'ట్రిప్ ముగింపులో మీ QR ఆటోమేటిక్‌గా కనిపిస్తుంది',
      removeUpi: 'తొలగించు',
      tipsTotal: 'మొత్తం టిప్స్',
      lifetimeRideEarnings: 'జీవితకాల రైడ్ ఆదాయం',
      rating: 'రేటింగ్',
      voiceAnnounceTitle: 'వాయిస్ ప్రకటనలు',
      voiceAnnounceSub: 'పికప్ & ఛార్జ్ తెలుగులో చదివి వినిపిస్తుంది',
      voiceEnabledToast: 'వాయిస్ ప్రకటనలు ఆన్ చేయబడ్డాయి 🔊',
      voiceDisabledToast: 'వాయిస్ ప్రకటనలు మ్యూట్ చేయబడ్డాయి 🔇',
      support: 'సపోర్ట్',
      callSupport: 'కాల్',
      waSupport: 'WhatsApp',
      rateApp: 'Play Storeలో MyTownly Annaకి రేటింగ్ ఇవ్వండి',
      rateAppSub: 'MyTownlyతో మీ అనుభవాన్ని పంచుకోండి',
      legalSectionTitle: '🔒 గోప్యత & లీగల్',
      legalSectionSub: 'మీ గోప్యత, KYC డాక్యుమెంట్ భద్రత, మరియు ప్లాట్‌ఫారమ్ నియమాలు.',
      legalDocsHeading: 'లీగల్ డాక్యుమెంట్లు',
      privacyTitle: '🛡️ గోప్యతా విధానం',
      privacySub: 'డ్రైవర్ డేటా రక్షణ & లొకేషన్ విధానం',
      termsTitle: '📜 సేవా నిబంధనలు',
      termsSub: 'డ్రైవర్ నిబంధనలు, ఛార్జీలు & ప్రవర్తనా నియమావళి',
      safetyHeading: 'భద్రత & మార్గదర్శకాలు',
      safetyTitle: '🦺 భద్రతా మార్గదర్శకాలు',
      safetySub: 'ప్యాసింజర్ & డ్రైవర్ భద్రతా ప్రమాణాలు',
      deleteTitle: '🗑️ ఖాతా తొలగించు',
      deleteSub: 'డ్రైవర్ ఖాతా & ప్రొఫైల్‌ను శాశ్వతంగా తొలగించు',
    },
    deleteAccount: {
      title: 'క్యాప్టెన్ ఖాతా తొలగించు',
      subtitle: 'మీ క్యాప్టెన్ ప్రొఫైల్ & రికార్డులను శాశ్వతంగా తొలగించండి',
      close: 'మూసివేయి',
      warning: 'తిరిగి పొందలేని చర్య: మీ క్యాప్టెన్ ఖాతాను తొలగిస్తే మీ డ్రైవర్ రిజిస్ట్రేషన్, వాహన ప్రొఫైల్, KYC డాక్యుమెంట్లు, మరియు ఆదాయ చరిత్ర శాశ్వతంగా రద్దవుతాయి.',
      phoneLabel: 'రిజిస్టర్ చేసిన ఫోన్ నంబర్',
      phonePlaceholder: '10 అంకెల మొబైల్ నంబర్',
      reasonLabel: 'వెళ్తున్న కారణం',
      feedbackLabel: 'అదనపు అభిప్రాయం (ఐచ్ఛికం)',
      feedbackPlaceholder: 'మేము ఎలా మెరుగుపడగలమో చెప్పండి…',
      reasons: {
        not_driving: 'ఇక MyTownlyతో డ్రైవ్ చేయడం లేదు',
        privacy_concerns: 'గోప్యత & డేటా ఆందోళనలు',
        switched_service: 'మరొక ప్లాట్‌ఫారమ్‌కు మారాను',
        vehicle_changed: 'వాహనం మారింది / అమ్మేశాను',
        other: 'ఇతర కారణం',
      },
      submit: 'నిర్ధారించి తొలగింపు అభ్యర్థించు',
      submitting: 'అభ్యర్థన సబ్మిట్ అవుతోంది…',
      keep: 'నా ఖాతాను ఉంచు',
      invalidPhone: 'సరైన 10 అంకెల ఫోన్ నంబర్ ఇవ్వండి',
      submitted: 'డ్రైవర్ ఖాతా తొలగింపు అభ్యర్థన సబ్మిట్ అయింది',
      failed: 'అభ్యర్థన సబ్మిట్ కాలేదు. దయచేసి సపోర్ట్‌ను సంప్రదించండి.',
      receivedTitle: 'అభ్యర్థన అందింది',
      receivedBody: '+91 {phone} కోసం మీ క్యాప్టెన్ ఖాతా తొలగింపు అభ్యర్థన నమోదైంది. మా ప్రైవసీ ఆఫీసర్ 30 రోజుల్లో తొలగింపును ప్రాసెస్ చేస్తారు.',
      trackWhatsapp: '💬 WhatsApp సపోర్ట్ ద్వారా ట్రాక్ చేయండి',
    },
    privacyCenter: {
      title: 'గోప్యత & డేటా సెంటర్',
      subtitle: 'మీ క్యాప్టెన్ ప్రొఫైల్, ప్రాధాన్యతలు, మరియు గోప్యతను నిర్వహించండి',
      close: 'మూసివేయి',
      gpsNoticeLabel: 'డ్రైవర్ GPS నోటీసు:',
      gpsNoticeBody: 'మీరు ఆన్‌లైన్‌లో ఉన్నప్పుడు, బుకింగ్‌లను మ్యాచ్ చేయడానికి మరియు యాక్టివ్ ట్రిప్‌లను ట్రాక్ చేయడానికి మీ లొకేషన్ షేర్ చేయబడుతుంది. ఆఫ్‌లైన్‌కు వెళ్తే వెంటనే షేరింగ్ ఆగిపోతుంది.',
      legalHeading: 'లీగల్ & విధానాలు',
      privacyPolicy: 'గోప్యతా విధానం',
      termsOfUse: 'వినియోగ నిబంధనలు',
      prefsHeading: 'గోప్యతా ప్రాధాన్యతలు',
      analyticsOptOut: 'అనలిటిక్స్ నుండి తప్పుకోండి',
      analyticsOptOutSub: 'వినియోగ డయాగ్నస్టిక్స్ & ఈవెంట్ టెలిమెట్రీని ఆపండి. ప్రధాన ట్రిప్ ప్రాసెసింగ్‌పై ప్రభావం ఉండదు.',
      promoUpdates: 'ప్రచార నవీకరణలు',
      promoUpdatesSub: 'అప్పుడప్పుడు డ్రైవర్ కమ్యూనిటీ బోనస్‌లు & ఊరి ప్రకటనలు పొందండి.',
      savePrefs: 'ప్రాధాన్యతలు సేవ్ చేయి',
      saving: 'సేవ్ అవుతోంది…',
      prefsUpdated: 'ప్రాధాన్యతలు నవీకరించబడ్డాయి',
      prefsFailed: 'ప్రాధాన్యతలు సేవ్ కాలేదు',
      nomineeHeading: 'నమ్మకమైన నామినీ',
      nomineeSub: 'మీరు చేయలేని పరిస్థితిలో మీ ఖాతా & రికార్డులను నిర్వహించగల నమ్మకమైన వ్యక్తిని జోడించండి.',
      nomineeNamePlaceholder: 'నామినీ పూర్తి పేరు',
      nomineePhonePlaceholder: 'నామినీ 10 అంకెల ఫోన్',
      saveNominee: 'నామినీని సేవ్ చేయి',
      nomineeInvalidPhone: 'సరైన 10 అంకెల నామినీ ఫోన్ ఇవ్వండి',
      nomineeSaved: 'నామినీ సేవ్ అయ్యారు',
      nomineeCleared: 'నామినీ తొలగించబడ్డారు',
      nomineeFailed: 'నామినీ సేవ్ కాలేదు',
      rightsHeading: 'మీ డేటా & ఖాతా',
      downloadData: 'వ్యక్తిగత డేటా డౌన్‌లోడ్',
      downloadDataSub: 'మీ ప్రాసెస్ చేసిన రికార్డుల కాపీని ఎక్స్‌పోర్ట్ చేయండి',
      accessSubmitted: 'యాక్సెస్ అభ్యర్థన సబ్మిట్ అయింది',
      accessFailed: 'అభ్యర్థన సబ్మిట్ కాలేదు',
      deleteTitle: 'ఖాతా తొలగించు & డేటా తుడిచివేయి',
      deleteSub: 'మీ ప్రొఫైల్ శాశ్వత తొలగింపు',
      grievanceHeading: 'గోప్యతా ఫిర్యాదు చేయండి',
      grievanceSub: 'మీ డేటా ఎలా నిర్వహించబడుతుందనే దానిపై సమస్య ఉందా? నేరుగా మా కంప్లయన్స్ డెస్క్‌కు సబ్మిట్ చేయండి.',
      grievancePlaceholder: 'మీ సమస్యను వివరంగా వివరించండి…',
      submitGrievance: 'ఫిర్యాదు సబ్మిట్ చేయి',
      submitting: 'సబ్మిట్ అవుతోంది…',
      grievanceShort: 'మీ సమస్యను వివరించండి (కనీసం 10 అక్షరాలు)',
      grievanceSubmitted: 'ఫిర్యాదు సబ్మిట్ అయింది',
      grievanceFailed: 'ఫిర్యాదు సబ్మిట్ కాలేదు',
      grievanceOfficer: 'ఫిర్యాదు అధికారి:',
      whatsappDesk: 'WhatsApp డెస్క్ ›',
    },
    chat: {
      title: 'చాట్',
      open: 'చాట్',
      empty: 'మెసేజ్‌లు లేవు',
      placeholder: 'కస్టమర్‌కు మెసేజ్…',
      send: 'పంపు',
      chipOnMyWay: 'నమస్తే, నేను వస్తున్నాను 🛺',
      chipArrived: 'పికప్ పాయింట్ వద్ద ఉన్నాను 📍',
      chipTraffic: 'ట్రాఫిక్ లో ఉన్నాను 🚦',
      chipEta: '2 నిమిషాల్లో వస్తాను ⏱️',
      chipCall: 'ఫోన్ తీయండి సర్ 📞',
    },
    push: {
      enable: 'రైడ్ అలర్ట్స్ ఆన్ చేయి',
      enabled: 'నోటిఫికేషన్స్ ఆన్',
      denied: 'నోటిఫికేషన్స్ ఆన్ కాలేదు',
      noVapid: 'REACT_APP_FIREBASE_VAPID_KEY సెట్ చేయండి',
      promptTitle: 'కొత్త రైడ్ అలర్ట్స్',
      promptBody: 'రిక్వెస్ట్ మిస్ కాకుండా నోటిఫికేషన్స్ ఆన్ చేయండి.',
      later: 'తర్వాత',
    },
    battery: {
      title: 'రైడ్ రిక్వెస్ట్‌లు మిస్ కాకుండా',
      body: 'కొన్ని ఫోన్‌లు (Xiaomi, Vivo, Oppo మొదలైనవి) బ్యాటరీ ఆదా కోసం యాప్‌లను బ్యాక్‌గ్రౌండ్‌లో ఆపేస్తాయి. స్క్రీన్ ఆఫ్‌లో ఉన్నా రైడ్ రిక్వెస్ట్‌లు మీకు చేరేలా MyTownly‌ను పరిమితులు లేకుండా రన్ కానివ్వండి.',
      allow: 'అనుమతించండి',
      later: 'ఇప్పుడు వద్దు',
      oemToggle: 'Xiaomi, Vivo లేదా Oppo వాడుతున్నారా?',
      oemHelp: 'ఫోన్ Settings → Apps → MyTownly Anna → Autostart (లేదా “Allow background activity”) తెరిచి ఆన్ చేయండి.',
      bannerText: 'ఈ ఫోన్‌లో రైడ్ రిక్వెస్ట్‌లు ఆలస్యం కావచ్చు',
      bannerFix: 'సరిచేయి',
      openFailed: 'బ్యాటరీ సెట్టింగ్స్ తెరవలేకపోయాం — ఫోన్ Settings → Apps → MyTownly Anna → Battery తెరవండి.',
    },
    tour: {
      next: 'తర్వాత',
      skip: 'దాటవేయి',
      done: 'సరే',
      online: {
        title: 'ఆన్‌లైన్ అవ్వండి',
        body: 'రైడ్ రిక్వెస్ట్‌లు పొందడానికి Go Online నొక్కండి.',
      },
      accept: {
        title: 'త్వరగా అంగీకరించండి',
        body: 'కొత్త రిక్వెస్ట్‌లు టైమర్‌తో వస్తాయి. గడువు ముందు Accept చేయండి.',
      },
      otp: {
        title: 'OTP తో ప్రారంభం',
        body: 'పికప్‌లో ప్యాసింజర్ యాప్‌లోని 4 అంకెల OTP అడగండి.',
      },
      cash: {
        title: 'నగదు తీసుకోండి',
        body: 'డ్రాప్‌లో ఛార్జీ నగదుగా తీసుకుని Complete నొక్కండి.',
      },
    },
    docs: {
      title: 'నా పత్రాలు & వాహనం',
      subtitle: 'పీలేరు ఆటో డ్రైవర్ KYC మరియు అనుమతులు',
      verifiedBadge: 'ధృవీకరించబడిన డ్రైవర్ 🛡️',
      pendingBadge: 'పరిశీలనలో ఉంది ⏳',
      missingBadge: 'పత్రాలు అవసరం ⚠️',
      dlTitle: 'డ్రైవింగ్ లైసెన్స్ (DL)',
      dlSub: 'వాణిజ్య రవాణా 3-వీలర్ లైసెన్స్',
      dlNumberLabel: 'లైసెన్స్ నంబర్',
      dlNumberPlaceholder: 'ఉదా: AP04 20200012345',
      dlExpiryLabel: 'లైసెన్స్ గడువు తేదీ',
      dlFrontPhoto: 'లైసెన్స్ ముందు ఫోటో',
      dlBackPhoto: 'లైసెన్స్ వెనుక ఫోటో',
      rcTitle: 'వాహన RC కార్డ్',
      rcSub: 'మీ ఆటో రిజిస్ట్రేషన్ సర్టిఫికేట్',
      rcNumberLabel: 'RC / ప్లేట్ నంబర్',
      rcOwnerLabel: 'యజమాని పేరు (RC ప్రకారం)',
      rcPhoto: 'RC కార్డ్ ఫోటో',
      insuranceTitle: 'ఆటో ఇన్సూరెన్స్ పాలసీ',
      insuranceSub: 'వాణిజ్య ప్యాసింజర్ ఇన్సూరెన్స్',
      insuranceNumberLabel: 'పాలసీ నంబర్',
      insuranceExpiryLabel: 'ఇన్సూరెన్స్ గడువు తేదీ',
      insurancePhoto: 'ఇన్సూరెన్స్ కాపీ ఫోటో',
      vehicleSpecsTitle: 'వాహనం & అత్యవసర వివరాలు',
      fuelTypeLabel: 'ఇంధనం రకం',
      petrol: 'పెట్రోల్',
      diesel: 'డీజిల్',
      lpg: 'LPG గ్యాస్',
      cng: 'CNG గ్యాస్',
      electric: 'ఎలక్ట్రిక్ (EV)',
      bloodGroupLabel: 'బ్లడ్ గ్రూప్',
      emergencyContactLabel: 'అత్యవసర కాంటాక్ట్ నంబర్',
      saveDocsBtn: 'పత్రాలను సమర్పించండి',
      savedToast: 'పత్రాలు సేవ్ చేయబడ్డాయి మరియు పరిశీలనకు పంపబడ్డాయి!',
      uploadFailed: 'అప్‌లోడ్ కాలేదు — సిగ్నల్ బాగున్నప్పుడు మళ్లీ ప్రయత్నించండి. సేవ్ చేయడానికి ముందు ఫోటోను మళ్లీ జోడించండి.',
      uploadPhotoBtn: 'ఫోటో అప్‌లోడ్ చేయండి',
      changePhotoBtn: 'ఫోటో మార్చండి',
      statusVerified: 'ధృవీకరించబడింది ✓',
      statusPending: 'పరిశీలనలో ఉంది ⏳',
      statusRejected: 'మళ్ళీ అప్‌లోడ్ చేయాలి ✕',
      statusNotUploaded: 'అప్‌లోడ్ కాలేదు',
      rejectionReason: 'అడ్మిన్ సూచన: {reason}',
      backToProfile: 'ప్రొఫైల్‌కు తిరిగి వెళ్లండి',
      menuRowTitle: 'పత్రాలు & వాహన KYC',
      menuRowSub: 'డ్రైవింగ్ లైసెన్స్, RC, ఇన్సూరెన్స్',
      priorityTag: 'ప్రయారిటీ 1.2x',
      heroVerified: 'అన్ని రవాణా అనుమతులు ధృవీకరించబడ్డాయి. మీకు వెరిఫైడ్ పార్టనర్ ప్రయారిటీ డిస్పాచ్ ఉంది.',
      heroPending: 'మీరు అప్‌లోడ్ చేసిన డాక్యుమెంట్లను MyTownly అడ్మిన్ టీమ్ సమీక్షిస్తోంది.',
      heroMissing: 'వెరిఫైడ్ పార్టనర్ బ్యాడ్జ్ పొందడానికి మీ DL, RC, ఇన్సూరెన్స్, మరియు ఆధార్ యొక్క స్పష్టమైన ఫోటోలు అప్‌లోడ్ చేయండి.',
      frontPhoto: 'ముందు ఫోటో',
      backPhoto: 'వెనుక ఫోటో',
      uploading: 'అప్‌లోడ్ అవుతోంది…',
      tapToCapture: 'ఫోటో తీయడానికి ట్యాప్ చేయండి',
      rcOwnerPlaceholder: 'యజమాని పూర్తి పేరు',
      uploadRcBtn: 'RC కార్డ్ / స్మార్ట్ కార్డ్ అప్‌లోడ్',
      rcDropSub: 'రిజిస్ట్రేషన్ సర్టిఫికేట్ యొక్క స్పష్టమైన ఫోటో',
      insuranceNumberPlaceholder: 'పాలసీ / కవర్ నోట్ #',
      uploadInsuranceBtn: 'ఇన్సూరెన్స్ పాలసీ కాపీ అప్‌లోడ్',
      insuranceDropSub: 'ప్రస్తుత చెల్లుబాటు అయ్యే పాలసీ డాక్యుమెంట్',
      aadhaarTitle: 'ఆధార్ కార్డ్',
      aadhaarSub: 'ప్రభుత్వ గుర్తింపు రుజువు (తప్పనిసరి)',
      aadhaarNumberLabel: 'ఆధార్ నంబర్',
      aadhaarNumberPlaceholder: '1234 5678 9012',
      aadhaarLast4Note: 'చివరి 4 అంకెలు మాత్రమే స్టోర్ చేయబడతాయి. పూర్తి నంబర్ మీ ఫోటో నుండి సరిచూడబడుతుంది, సేవ్ చేయబడదు.',
      aadhaarPhoto: 'ఆధార్ కార్డ్ ఫోటో',
      uploadAadhaarBtn: 'ఆధార్ కార్డ్ అప్‌లోడ్',
      aadhaarDropSub: 'మీ ఆధార్ ముందు వైపు స్పష్టమైన ఫోటో',
      vehicleSpecsSub: 'ఇంధన రకం, బ్లడ్ గ్రూప్, & హైవే ఎమర్జెన్సీ',
    },
    nav: { home: 'హోమ్', earnings: 'ఆదాయం', profile: 'ప్రొఫైల్' },
    requiredUpdate: {
      versionLine: 'వెర్షన్ {version} లేదా అంతకంటే కొత్తది అవసరం',
      updateNow: 'ఇప్పుడు అప్‌డేట్ చేయండి',
      opening: 'Google Play తెరుస్తోంది…',
      idleNote: 'ట్రిప్ బయట, ఓపెన్ రైడ్ రిక్వెస్ట్ లేనప్పుడు మాత్రమే ఇది కనిపిస్తుంది.',
    },
    intertown: {
      eyebrow: 'ఇంటర్ టౌన్ అసైన్‌మెంట్',
      destinationFallback: 'గమ్యస్థానం',
      oneWay: 'వన్ వే',
      returnTrip: 'రిటర్న్ ట్రిప్',
      pickupLabel: 'పికప్:',
      pickupFallback: 'ప్రయాణికుడి వివరాలు చూడండి',
      passengerFallback: 'ప్యాసింజర్',
      passengerLabel: 'ప్యాసింజర్',
      tripLabel: 'ట్రిప్',
      distanceLabel: 'దూరం',
      fareLabel: 'ఛార్జీ',
      offerStatus: 'కొత్త ఆఫర్',
      toPickupStatus: 'పికప్‌కు వెళ్లండి',
      otpStatus: 'పికప్ ధృవీకరించండి',
      onTripStatus: 'ట్రిప్ కొనసాగుతోంది',
      destinationStatus: 'గమ్యస్థానంలో',
      returnStatus: 'తిరుగు ప్రయాణం',
      decline: 'తిరస్కరించండి',
      accept: 'ఇంటర్ టౌన్ అంగీకరించండి',
      navigatePickup: 'పికప్‌కు నావిగేట్ చేయండి',
      navigateDestination: 'గమ్యస్థానానికి నావిగేట్ చేయండి',
      arrivedAtPickup: 'పికప్‌కు చేరుకున్నారు',
      updating: 'అప్‌డేట్ అవుతోంది…',
      startTrip: 'ట్రిప్ ప్రారంభించు',
      otpHint: 'ప్యాసెంజర్ యొక్క ఇంటర్ టౌన్ స్క్రీన్‌లో ఉన్న 4 అంకెల కోడ్ అడగండి',
      reachedDestination: 'గమ్యస్థానం చేరుకున్నారు',
      waitingStarted: 'వేచి ఉండే సమయం ప్రారంభమైంది.',
      startReturn: 'తిరుగు ప్రయాణం ప్రారంభించండి',
      finalFare: 'తుది ఛార్జీ {amount}',
      completeTrip: 'ట్రిప్ పూర్తి చేయండి',
      offerDeclined: 'ఇంటర్ టౌన్ ఆఫర్ తిరస్కరించబడింది',
      tripUpdated: 'ఇంటర్ టౌన్ ట్రిప్ అప్‌డేట్ అయింది',
      updateFailed: 'ఇంటర్ టౌన్ ట్రిప్‌ను అప్‌డేట్ చేయలేకపోయాము',
      waitingForLocation: 'మీ ప్రస్తుత GPS లొకేషన్ కోసం వేచి ఉంది. పికప్ చేరుకున్నట్లు నిర్ధారించడానికి లొకేషన్ ఆన్‌లో ఉంచి యాప్‌ను తెరిచి ఉంచండి.',
      availableTitle: 'అందుబాటులో ఉన్న ఇంటర్ టౌన్ ట్రిప్‌లు',
      availableSubtitle: 'ముందుగా క్లెయిమ్ చేసిన అన్నకు ట్రిప్ వస్తుంది',
      claim: 'క్లెయిమ్ చేయండి',
      notNow: 'ఇప్పుడు వద్దు',
      claimed: 'ఇంటర్ టౌన్ ట్రిప్ క్లెయిమ్ అయింది',
      declinedOpen: 'మీకు 10 నిమిషాల పాటు కొత్త ఇంటర్ టౌన్ ఆఫర్‌లు కనిపించవు',
      claimFailed: 'ఈ ఇంటర్ టౌన్ ట్రిప్ ఇక అందుబాటులో లేదు',
    },
  },
};
